import { BlockDefinition } from "@softr-io/blocks-sdk";

export function isCustomCodeBlock(block: Pick<BlockDefinition, "name">): boolean {
    return block.name.startsWith("custom-code");
}
